const SVG = ({
  fill = 'none',
  stroke = 'currentColor',
  width = '14',
  height = '20',
  viewBox = '0 0 14 20',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    stroke={stroke}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.5 7h7M3.5 10h7M3.5 13h7M3.5 16h7" strokeWidth="1.25" strokeLinecap="round" />
    <path
      clipRule="evenodd"
      d="M1 5a1 1 0 011-1h10a1 1 0 011 1v13a1 1 0 01-1 1H2a1 1 0 01-1-1V5zM4 2a1 1 0 011-1h4a1 1 0 011 1v2H4V2z"
      strokeWidth="1.25"
    />
  </svg>
)

export default SVG
